<template>
    <auth-layout :image="1" :byword="$t('pages.auth.signup.steps.physician_password.byword')" :isProgressBarHidden="true">
        <common-content-wrapper width="small">
            <common-page-header
                :heading="
                    $t('pages.auth.signup.steps.physician_password.heading', {
                        physicianFullName: $route.query.name,
                    })
                "
                :content="
                    $t('pages.auth.signup.steps.physician_password.description', { practiceName: $route.query.practiceName })
                "
                contentSpacing="medium"
            ></common-page-header>
            <set-password-form @sent="afterSent()"></set-password-form>
        </common-content-wrapper>
    </auth-layout>
</template>

<script>
    import AuthLayout from '../../components/layouts/AuthLayout'
    import SetPasswordForm from 'components/forms/AuthSetPasswordForm'

    export default {
        mixins: [],

        components: {
            AuthLayout,
            SetPasswordForm,
        },

        methods: {
            afterSent() {
                this.$router.push(this.$route.query.redirect || { name: 'index' })
            },
        },
    }
</script>
